import * as XLSX from "xlsx";
import { Student } from "./types";
import { Address } from "./apis/AddressAPI";
import { getInitialStaffAttendanceData, getInitialStaffData, StaffAttendanceDTO, StaffDTO, StaffType } from "./apis/StaffAPI";

export function utilMethods() { }

export function exportToExcel<T>(feeList: T[], fileName: string) {
  console.log(">>> Util::exportToExcel");
  console.log(feeList);
  console.log(fileName);
  if (feeList.length === 0) {
    alert("Empty list");
    return;
  }
  const worksheet = XLSX.utils.json_to_sheet(feeList);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.writeFile(workbook, fileName + ".xlsx");
}

export function getCurrentTerm(): number {
  let currMonth = new Date().getMonth();

  switch (currMonth) {
    case 5:
    case 6:
    case 7:
      return 1;
    case 8:
    case 9:
    case 10:
      return 2;
    case 11:
    case 0:
    case 1:
      return 3;
    case 2:
    case 3:
    case 4:
      return 4;
  }

  return -1;
}

export function getStaticGrades(): string[] {
  let staticGrades: string[] = ["PRE-KG", "LKG", "UKG", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten"];
  return staticGrades;
}

export function getStaticSections(): string[] {
  let staticGrades: string[] = ["A", "B"];
  return staticGrades;
}

export function getStaticAreas(): string[] {
  let staticAreas: string[] = [
    "",
    "Adugodi",
    "Amrutahalli",
    "Anekal",
    "Anjanapura",
    "Anwar layout",
    "Arabic College Bangalore North",
    "Arekere",
    "Attibele",
    "Attur",
    "Austin Town",
    "Bamboo bazaar",
    "Banashankari",
    "Banaswadi",
    "Basavanagudi",
    "Basaveshwaranagar",
    "Bellandur",
    "Benson Town Bangalore North",
    "Begur",
    "Brookefield",
    "BTM Layout",
    "Byatarayanapura",
    "Chandra Layout",
    "Chandapura",
    "Chinaappa garden",
    "Chikkabanavara",
    "Coles park",
    "cooke  town",
    "Cox Town",
    "CV Raman Nagar",
    "Davis road",
    "Devanahalli",
    "DJ halli",
    "Doddanekundi",
    "Doddaballapur",
    "Domlur",
    "Ejipura",
    "Fraser Town",
    "Fraser Town Bangalore North",
    "Girinagar",
    "Govindpur",
    "Gottigere",
    "HBR Layout",
    "Hebbal",
    "Hennur",
    "Hesaraghatta",
    "Hoodi",
    "Horamavu",
    "Hosakerehalli",
    "Hoskote",
    "Hulimavu",
    "Hulsur Bazaar Bangalore North",
    "hutchins road",
    "Indiranagar",
    "J.c.nagar Bangalore North",
    "Jalahalli",
    "Jayanagar",
    "Jigani",
    "JP Nagar",
    "Kaggadasapura",
    "Kamakshipalya",
    "Kammanahalli",
    "Kanakapura Road",
    "Kalyan Nagar",
    "Kengeri",
    "Kodigehalli",
    "Kogilu",
    "Koramangala",
    "Krishnarajapuram (KR Puram)",
    "Kumaraswamy Layout",
    "Kundaswamy mudailar road",
    "Kuvempu Nagar",
    "Lakkasandra",
    "Lingarajapuram",
    "Lingarajapuram Bangalore North",
    "Magadi Road",
    "Magdi road",
    "Madiwala",
    "Mahadevapura",
    "Mahalakshmi Layout",
    "Marappa  Garden",
    "Marathahalli",
    "Mathikere",
    "MG Road",
    "Nagarbhavi",
    "Nagavara",
    "Nandini Layout",
    "Nelamangala",
    "Padmanabhanagar",
    "P&t Col. Kavalbyrasand Braangalore North",
    "Peenya",
    "pottery town",
    "R T Nagar Bangalore North",
    "RT Nagar",
    "Rajarajeshwari Nagar",
    "Rajajinagar",
    "Ramamurthy Nagar",
    "Ramanagara",
    "Richards park",
    "Richmond Town",
    "Sadashivanagar",
    "Sahakara Nagar",
    "Sanjay Nagar",
    "Sarjapur",
    "Seshadripuram",
    "Shanthinagar",
    "Shivajinagar",
    "SK Garden",
    "Suddagunte Palya",
    "Sunkadakatte",
    "Tannery road",
    "Thanisandra",
    "Thanisandar",
    "Thavarekere",
    "Thimmaiha road",
    "Ulsoor (Halasuru)",
    "Uttarahalli",
    "Varthur",
    "Vasanth Nagar",
    "Vidyaranyapura",
    "Vidhana Soudha area",
    "Vijayanagar",
    "wahab garden",
    "Whitefield",
    "willams town",
    "Yelahanka",
    "yaseen nagar",
    "Yeshwanthpur",
    "OTHER",
  ];
  return staticAreas;
}

export function getPreviousYears(noOfPreviousYears: number): number[] {
  // Get the current year
  const currentYear = new Date().getFullYear();
  // Generate an array of the previous 15 years
  const previous15Years = [];
  for (let i = 0; i <= noOfPreviousYears; i++) {
    previous15Years.push(currentYear - i);
  }
  return previous15Years;
}

export function getStaticLanguages(): string[] {
  return [
    "",
    "Assamese",
    "Bengali",
    "Bhili",
    "Bodo",
    "Chakma",
    "Dogri",
    "English",
    "Gondi",
    "Gujarati",
    "Hindi",
    "Kannada",
    "Kashmiri",
    "Khasi",
    "Kokborok",
    "Konkani",
    "Ladakhi",
    "Lepcha",
    "Maithili",
    "Malayalam",
    "Manipuri",
    "Marathi",
    "Mizo",
    "Nepali",
    "Odia",
    "Punjabi",
    "Sanskrit",
    "Santali",
    "Sindhi",
    "Tamil",
    "Telugu",
    "Tulu",
    "Urdu",
  ];
}

export function getStaticBloodGroups(): string[] {
  return ["", "A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-", "Un Known"];
}

export function getStudentRelations(): string[] {
  return [
    "Aunt",
    "Brother",
    "Cousin",
    "Father",
    "Grandfather",
    "Grandmother",
    "Mother",
    "Sister",
    "Stepbrother",
    "Stepfather",
    "Stepmother",
    "Stepsister",
    "Uncle",
    "Other",
  ];
}

export function getStudentEmergencyRelations(): string[] {
  return [
    "Aunt",
    "Brother",
    "Cousin",
    "Father",
    "Grandfather",
    "Grandmother",
    "Guardian",
    "Mother",
    "Sister",
    "Stepbrother",
    "Stepfather",
    "Stepmother",
    "Stepsister",
    "Uncle",
    "Other",
  ];
}

export function getStudentRelationsExceptParents(): string[] {
  let exceptParents = getStudentRelations().filter(relation => relation !== 'Father' && relation !== 'Mother');
  return exceptParents;
}

export function getStates(): string[] {
  return [
    "",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];
}
export function getReligions(): string[] {
  return ["", "Buddhism", "Christianity", "Hinduism", "Islam", "Jainism", "Judaism", "Sikhism", "Zoroastrianism"];
}

export function getNationalities(): string[] {
  return [
    "",
    "American",
    "Australian",
    "Brazilian",
    "British",
    "Canadian",
    "Chinese",
    "French",
    "German",
    "Indian",
    "Indonesian",
    "Italian",
    "Japanese",
    "Korean",
    "Mexican",
    "Pakistani",
    "Russian",
    "Saudi Arabian",
    "South African",
    "Spanish",
    "Turkish",
  ];
}

export function isPresentAndPermanentAddressEqual(student: Student): boolean {
  if (student === undefined || student === null) return false;

  let present: Address = student.present;
  let permanent: Address = student.permanent;
  if (
    present?.houseNo === permanent?.houseNo &&
    present?.areaLocality === permanent?.areaLocality &&
    present?.streetRoad === permanent?.streetRoad &&
    present?.city === permanent?.city &&
    present?.state === permanent?.state
  )
    return true;
  else return false;
}

export const getMobileFont = () => {
  return "16px";
};

export const formatNumber = (num: number): string => {
  const absNum = Math.abs(num);

  if (absNum >= 1.0e9) {
    return (num / 1.0e9).toFixed(1).replace(/\.0$/, "") + "B";
  }
  if (absNum >= 1.0e6) {
    return (num / 1.0e6).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (absNum >= 1.0e3) {
    return (num / 1.0e3).toFixed(1).replace(/\.0$/, "") + "k";
  }

  return num.toString();
};

export const getTeachingFaculties = (): StaffAttendanceDTO[] => {
  let names = [
    "Abdul Mateen",
    "Aasiya Banu",
    "Ameena",
    "Arshiya",
    "Arshiya Nazneen",
    "Asma",
    "Ayesha Arifulla",
    "Daniya",
    "Fadia",
    "Hafiz Fazil Pasha",
    "Hafsa Ashfaq",
    "Hajira",
    "Hemalatha",
    "Hiba Fathima",
    "Hoorullain",
    "Javeriya Suhail",
    "Mahamad Sadiq Pasha",
    "Mehtab Begum",
    "Mohammed Sulaiman",
    "Muskaan",
    "Muzammil Pasha",
    "Nabeela Banu",
    "Nargis Tabassum",
    "Nazeema Jan",
    "Saima",
    "Saba",
    "Sadiya",
    "Samayya",
    "Shabana Parveen",
    "Shabreen Zameer",
    "Shafia Tabassum",
    "Shakti Shankar",
    "Shumaila",
    "Sofia",
    "Sultana Begum",
    "Syeda Asma",
    "Tasmiya",
    "Tasneem Kausar",
    "Umme Kulsum",
    "Zareen Khan",
    "Zarina Malik",
    "Zeenath Begum",
  ];

  const teachingFaculties: StaffAttendanceDTO[] = [];
  for (let i = 0; i < names.length; i++) {
    let faculty = getInitialStaffAttendanceData();
    faculty.name = names[i];
    faculty.phone = i + 1;
    teachingFaculties.push(faculty);
  }

  return teachingFaculties;
};

export const getGroundStaff = (): StaffAttendanceDTO[] => {
  let gS = ["Hajira", "Jabin Taj", "Mubeena", "Parveen Taj", "Salma", "Shabeena", "Shakira", "Zaibunnisa"];
  const gFaculties: StaffAttendanceDTO[] = [];
  for (let i = 0; i < gS.length; i++) {
    let faculty = getInitialStaffAttendanceData();
    faculty.name = gS[i];
    faculty.phone = i + 100;
    gFaculties.push(faculty);
  }
  return gFaculties;
};

export const getSecurityStaff = (): StaffAttendanceDTO[] => {
  let sS = ["Abdul Ohab Sardar", "Ismail Khan", "Mohammed Sadiq"];
  const sFaculties: StaffAttendanceDTO[] = [];
  for (let i = 0; i < sS.length; i++) {
    let faculty = getInitialStaffAttendanceData();
    faculty.name = sS[i];
    faculty.phone = i + 200;

    sFaculties.push(faculty);
  }
  return sFaculties;
};

export const getAdminStaff = (): StaffAttendanceDTO[] => {
  let aS = ["Misbah Shaher T R", "Yasmeen Taj"];
  const aFaculties: StaffAttendanceDTO[] = [];
  for (let i = 0; i < aS.length; i++) {
    let faculty = getInitialStaffAttendanceData();
    faculty.name = aS[i];
    faculty.phone = i + 300;
    aFaculties.push(faculty);
  }
  return aFaculties;
};

export const calculateSumOfValuesOfMap = (data: any[]): number => {
  if (data === undefined) return undefined;
  const sumOfValues = data.reduce((x, y) => {
    let sum = 0;
    if (y) {
      const values = Object.values(y).slice(1);
      values.forEach((val) => {
        sum += parseInt(val as string);
      });
    }
    return x + sum;
  }, 0);
  return sumOfValues;
};
